<template>
  <div>
    <span>{{ item.nome }} - {{ item.filial.nome }} - {{ item.cargo }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true },
  },
}

</script>
